import { render, staticRenderFns } from "./tablaGeneros.vue?vue&type=template&id=10c6ed6c&scoped=true&"
import script from "./tablaGeneros.vue?vue&type=script&lang=js&"
export * from "./tablaGeneros.vue?vue&type=script&lang=js&"
import style0 from "./tablaGeneros.vue?vue&type=style&index=0&id=10c6ed6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c6ed6c",
  null
  
)

export default component.exports